import { getConnectionState, type ConnectionState } from '../realtime/hubClient';
import './ConnectionIndicator.css';

interface Presentation {
  label: string;
  tone: 'ok' | 'warn' | 'error';
  aria: string;
}

/** Map hub state → what the badge shows. Muted for the calm case (connected),
 *  louder wording when we're not. */
function presentation(state: ConnectionState): Presentation {
  switch (state) {
    case 'connected':
      return { label: 'Live', tone: 'ok', aria: 'Live-Verbindung aktiv' };
    case 'connecting':
      return { label: 'Verbinde…', tone: 'warn', aria: 'Verbinde zum Live-Kanal' };
    case 'reconnecting':
      return { label: 'Reconnect', tone: 'warn', aria: 'Live-Kanal reconnected' };
    case 'disconnected':
      return { label: 'Offline', tone: 'error', aria: 'Live-Verbindung getrennt' };
  }
}

/**
 * Small live/offline pill for the AppShell top bar. Reads the hub-client's
 * connection-state signal directly, so it re-renders precisely when the hub
 * transitions state.
 */
export function ConnectionIndicator() {
  const state = getConnectionState().value;
  const p = presentation(state);
  return (
    <span
      class={`hv-conn hv-conn--${p.tone}`}
      role="status"
      aria-live="polite"
      aria-label={p.aria}
      title={p.aria}
    >
      <span class="hv-conn__dot" />
      <span class="hv-conn__label">{p.label}</span>
    </span>
  );
}
